import SearchIcon from "@mui/icons-material/Search";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAuditFilters,
  setAuditDateRange,
  setAuditSearch,
} from "../../store/slices/auditTrailSlice";

const AuditFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectAuditFilters);
  const [searchValue, setSearchValue] = useState(filters.search);
  const startRef = useRef(null);
  const endRef = useRef(null);

  useEffect(() => {
    setSearchValue(filters.search);
  }, [filters.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setAuditSearch(searchValue.trim()));
    }, 300);
    return () => clearTimeout(timer);
  }, [dispatch, searchValue]);

  const changeDate = (key) => (event) => {
    const value = event.target.value || null;
    dispatch(
      setAuditDateRange({
        startDate: key === "startDate" ? value : filters.startDate,
        endDate: key === "endDate" ? value : filters.endDate,
      })
    );
  };

  const openPicker = (ref) => () => {
    const input = ref.current;
    if (!input) return;
    const wasReadOnly = input.readOnly;
    input.readOnly = false;
    if (input.showPicker) {
      try {
        input.showPicker();
      } catch {
        input.focus();
      }
    } else {
      input.focus();
    }
    input.readOnly = wasReadOnly;
  };

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        placeholder="Search admin name, email, or activity"
        value={searchValue}
        onChange={(event) => setSearchValue(event.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        sx={{ width: "100%" }}
      >
        <TextField
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={filters.startDate || ""}
          onChange={changeDate("startDate")}
          inputRef={startRef}
          onClick={openPicker(startRef)}
          InputProps={{ readOnly: true }}
          inputProps={{ style: { cursor: "pointer" } }}
        />
        <TextField
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={filters.endDate || ""}
          onChange={changeDate("endDate")}
          inputRef={endRef}
          onClick={openPicker(endRef)}
          InputProps={{ readOnly: true }}
          inputProps={{ style: { cursor: "pointer" } }}
        />
      </Stack>
      <Typography variant="body2" color="text.secondary">
        Showing audit logs for the selected period.
      </Typography>
    </Stack>
  );
};

export default AuditFilters;
